import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AssistantMarkdownContent = styled(Box)(({ theme }) => ({
  ...theme.typography.subtitle7,
  lineHeight: 1.6,
  overflowWrap: "anywhere",
  "& > :first-child": { marginTop: 0 },
  "& > :last-child": { marginBottom: 0 },
  // eslint-disable-next-line spellcheck/spell-checker -- Standard HTML element names.
  "& p, & ul, & ol, & blockquote, & pre": {
    marginTop: 0,
    marginBottom: theme.spacing(4),
  },
  "& h1, & h2": {
    ...theme.typography.subtitle1,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  "& h3, & h4, & h5, & h6": {
    ...theme.typography.h3,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  "& strong": { fontWeight: theme.fontWeight._600 },
  "& ul, & ol": { paddingLeft: theme.spacing(5) },
  "& li": { marginBottom: theme.spacing(2) },
  "& li > p": { marginBottom: theme.spacing(2) },
  "& li > ul, & li > ol": { marginBottom: 0 },
  "& a": {
    color: theme.palette.primary.main,
    textDecoration: "underline",
  },
  "& a:focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: theme.spacing(1),
  },
  // eslint-disable-next-line spellcheck/spell-checker -- Standard HTML element names.
  "& blockquote": {
    marginLeft: 0,
    marginRight: 0,
    paddingLeft: theme.spacing(4),
    borderLeft: `2px solid ${theme.palette.custom.semantic.border.default}`,
  },
  "& code": {
    backgroundColor: theme.palette.custom.semantic.surface.hover,
    borderRadius: theme.shape.borderRadius[1],
    padding: theme.spacing(0, 1),
  },
  "& pre": {
    whiteSpace: "pre-wrap",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.semantic.surface.hover,
    borderRadius: theme.shape.borderRadius[1],
  },
  "& pre code": { padding: 0 },
  "& hr": {
    border: 0,
    borderTop: `1px solid ${theme.palette.custom.semantic.border.default}`,
    margin: theme.spacing(4, 0),
  },
}));
